export default __webpack_public_path__ + "static/media/xolo.139c67d0.png";